import classNames from "classnames";
import { NavLink } from "react-router-dom";

import Icon from "assets/icons";
import { getIconForHeader } from "./utils";
import useProgramHeaderService from "./service";
import { useCopies } from "shared/hooks/useCopies";
import { ProgramStatusType } from "shared/types/ProgramStatusType";
import Carousel, { CarouselItem } from "shared/components/carousel";
import { ProgramHeaderItemWithStatus, ProgramHeaderPropTypes } from "./types";

function ProgramHeader(props: ProgramHeaderPropTypes) {
  const service = useProgramHeaderService(props);
  if (!props.programDetails.programStatus) return null;
  return (
    <div className="workflowheader">
      {service.programHeaders.length > 0 && (
        <Carousel activeIndex={service.programHeaders.findIndex(o => o.path === service.defaultPath)}>
          {service.programHeaders.map(o => (
            <HeaderItem key={o.path} details={o} />
          ))}
        </Carousel>
      )}
    </div>
  );
}

export default ProgramHeader;

function HeaderItem(props: { details: ProgramHeaderItemWithStatus<ProgramStatusType> }) {
  const copies = useCopies();

  return (
    <CarouselItem className="workflowheader_tabItem">
      <NavLink
        to={`/${props.details.path}`}
        className={classNames({
          disabled: !props.details.enabled
        })}>
        {getIconForHeader(props.details.status)}
        {copies.get(props.details.labelKey)}
      </NavLink>
      <Icon.ArrowRight />
    </CarouselItem>
  );
}
